



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class BffTextLabel extends Vue {
  @Prop({ default: '所属组织：' }) leftText!: String;
  @Prop({ default: '北京星河璀璨网络科技有限责任公司' }) rightText!: String;

  @Prop({ default: false }) isPhone!: Boolean;

  @Prop({ default: true }) showColon!: Boolean;

  setRightText(value) {
    if (!this.isPhone) {
      return value;
    }
    return value.replace(value?.substr(3, 4), '****');
  }
}
